import {
  changePasswordPath,
  checkCodeResetPassword,
  getCompanyFormList,
  getCountryFormList,
  getExpInfoUser,
  getRankList,
  getRoleList,
  getStoreFormList,
  registrationCodeVerify,
  resetPasswordPath,
  sendResetPasswordPath,
  updateUser,
  updateUserImage,
  userInfo,
  userLogin,
  userLogout,
  userRegistration,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { securityActions } from "../reducers/security";
import { t } from "i18next";
import { toast } from "react-toastify";

export const login = (loginRequest, navigate) => {
  return (dispatch) => {
    return apiService
      .post(userLogin(), loginRequest)
      .then((response) => {
        let loggedUser = response.data;

        localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
        dispatch(securityActions.setCurrentUser(loggedUser));

        //setovanje verzije aplikacije
        // const appVersion = response.headers["x-application-version"];
        // localStorage.setItem("appVersion", appVersion);

        navigate("/");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const sendResetPassword = (loginRequest, navigate) => {
  return (dispatch) => {
    return apiService
      .post(sendResetPasswordPath(), loginRequest)
      .then((response) => {
        toast.success(t("security.reset.success"), {
          theme: "colored",
        });
        navigate("/forgot-password-code");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchResetPassword = (loginRequest, navigate) => {
  return (dispatch) => {
    return apiService
      .post(resetPasswordPath(), loginRequest)
      .then((response) => {
        toast.success(t("security.reset.password.success"), {
          theme: "colored",
        });
        navigate("/login");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const registration = (registrationRequest, navigate) => {
  return (dispatch) => {
    return apiService
      .post(userRegistration(), registrationRequest)
      .then((response) => {
        toast.success(t("security.registration.success"), {
          theme: "colored",
        });
        navigate("/registration-code");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const logout = (navigate) => {
  return (dispatch) => {
    return apiService
      .post(userLogout())
      .then((response) => {
        localStorage.removeItem("appVersion");
        localStorage.removeItem("loggedUser");
        dispatch(securityActions.setCurrentUser({}));
        navigate("/"); // Preusmeravanje na početnu stranu
      })
      .catch((err) => {
        localStorage.removeItem("appVersion");
        localStorage.removeItem("loggedUser");
        dispatch(securityActions.setCurrentUser({}));
        navigate("/"); // Preusmeravanje na početnu stranu
        handleError(err);
      });
  };
};

export const changePassword = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(changePasswordPath(), data)
      .then((response) => {
        navigate("/settings");
        toast.success(t("security.change.password.success"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRoleList = (id_role = 0) => {
  return (dispatch) => {
    return apiService
      .get(getRoleList(id_role))
      .then((response) => {})
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserInfoExp = () => {
  return (dispatch) => {
    return apiService
      .get(getExpInfoUser())
      .then((response) => {
        dispatch(securityActions.fetchUserInfoExp(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserInfo = () => {
  return (dispatch) => {
    return apiService
      .get(userInfo())
      .then((response) => {
        dispatch(securityActions.fetchUserInfo(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUpdateUser = (formData) => {
  return (dispatch) => {
    return apiService
      .put(updateUser(), formData)
      .then((response) => {
        toast.success(t("security.update.user.success"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRegistrationCode = (formData, navigate) => {
  return (dispatch) => {
    return apiService
      .put(registrationCodeVerify(), formData)
      .then((response) => {
        toast.success(t("security.registration.code.success"), {
          theme: "colored",
        });
        navigate("/login");
      })
      .catch((err) => {
        toast.error(t("security.registration.code.error"), {
          theme: "colored",
        });
        // handleError(err);
      });
  };
};

export const fetchCheckCodeResetPassword = (formData) => {
  return (dispatch) => {
    return apiService
      .post(checkCodeResetPassword(), formData)
      .then((response) => {
        toast.success(t("reset.code.success"), {
          theme: "colored",
        });
        return Promise.resolve({ success: true });
      })
      .catch((err) => {
        toast.error(t("security.reset.code.error"), {
          theme: "colored",
        });
        return Promise.resolve({ success: false });
        // handleError(err);
      });
  };
};

export const fetchSubmitCodeResetPassword = (formData, navigate) => {
  return (dispatch) => {
    return apiService
      .post(resetPasswordPath(), formData)
      .then((response) => {
        toast.success(t("security.password.submit.success"), {
          theme: "colored",
        });
        navigate("/login");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUpdateUserImage = (formData) => {
  return (dispatch) => {
    return apiService
      .putMultipart(updateUserImage(), formData)
      .then((response) => {
        dispatch(fetchUserInfo());
        toast.success(t("security.update.user.success"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCompanyFormList = (id_company = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCompanyFormList(id_company))
      .then((response) => {
        dispatch(securityActions.fetchCompanyFormList(response.data));
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(t("security.error.refresh"), { theme: "colored" });
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchCountryList = (id_company = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCountryFormList(id_company))
      .then((response) => {
        dispatch(securityActions.fetchCountryFormList(response.data));
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(t("security.error.refresh"), { theme: "colored" });
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchStoreFormList = (id_company = 0) => {
  return (dispatch) => {
    return apiService
      .get(getStoreFormList(id_company))
      .then((response) => {
        dispatch(securityActions.fetchStoreFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRankList = () => {
  return (dispatch) => {
    return apiService
      .get(getRankList())
      .then((response) => {
        dispatch(securityActions.fetchRankList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
